import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  Label,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import { Avatar } from 'antd';
import images from 'assets/images';
import Button from 'components/App/Button';
import IconStarDiscovery from 'components/App/IconStarDiscovery';
import ImagePreview from 'components/App/ImagePreview';
import INITIAL_VALUE from 'constants/initialValue';
import moment from 'moment';
import { ReactComponent as IconThumbDown } from 'assets/images/thumb-down.svg';
import { ReactComponent as IconThumbUp } from 'assets/images/thumb-up.svg';

import { themeColor } from 'constants/index';
import axiosClient from 'utils/axios';
import { getRatingText } from 'utils';
import styles from './ModalDetailReview.module.scss';

const cx = classNames.bind(styles);

const getAddress = (place) => [
  place.address,
  // place.ward,
  // place.district,
  // place.province?.name,
].filter(Boolean).join(', ');

function DiscoverPlace({ id }) {
  const [place, setPlace] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const response = await axiosClient.get(`/discover-places/${id}`);
        setPlace(response.data.payload);
      } catch {
        setPlace(null);
      }
    })();
  }, [id]);

  if (!place) return null;
  return (
    <>
      <div className={cx('Header')}>
        <img
          src={place.previewImage}
          alt="location-avatar"
          className={cx('Avatar')}
        />

        <div className={cx('TitleGroup')}>
          <span className={cx('UserName')}>{place.name}</span>
          <span className={cx('SubText')}>{getAddress(place)}</span>
        </div>
      </div>

      <div className={cx('Divider')} />
    </>
  );
}

function ModalDetailReview(props) {
  const {
    isOpen,
    onCloseModal,
    locationDetail,

    onOpenDetailLocation,
  } = props;

  if (!locationDetail) {
    return null;
  }

  const {
    star,
    user,
    title,
    content,
    images: reviewImages,
    comeAt,
    discoverPlace,
  } = locationDetail;

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={onCloseModal}
      contentClassName={cx('Modal')}
      className={cx('ModalOverplay')}
    >
      <ModalBody className={cx('ModalBody')}>
        <Button
          isDefault
          classes={cx('Button__Close')}
          onClick={onCloseModal}
        >
          <img
            src={images.modalClose.default}
            alt="close"
            className="img-fluid img-close"
          />
        </Button>

        {discoverPlace
          && discoverPlace._id
          && <DiscoverPlace id={discoverPlace._id} />
        }

        <div className={cx('SectionWrapper')}>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center gap-2">
              <Avatar
                src={user.avatar}
                alt="user-avatar"
                size={32}
                round
              >
                {user.fullName.charAt(0).toUpperCase()}
                {user.fullName.charAt(1).toUpperCase()}
              </Avatar>

              <span className={cx('UserName')}>{user.fullName}</span>
            </div>

            <div className="d-flex gap-4 align-items-center">
              <Label className={cx('StarPoint')}>
                {getRatingText(star)}
              </Label>

              <IconStarDiscovery star={star} size={12} />
            </div>
          </div>

          <div className={cx('Section')}>
            <Label className={cx('Title')}>
              {title}
            </Label>

            <p className={cx('Content')}>
              {content}
            </p>
          </div>

          {reviewImages.length > 0 && (
            <div>
              <ImagePreview images={reviewImages} />
            </div>
          )}

          <div className={cx('VisitDate')}>
            <span>Ngày đến thăm:</span>
            {' '}
            {comeAt ? moment(comeAt).format('[tháng] M [năm] YYYY') : ''}
          </div>

          <div className={cx('ReactionContainer')}>
            <div className={cx('ReactionItem')}>
              <IconThumbUp width={16} height={16} />
              <span>10</span>
            </div>

            <div className={cx('ReactionItem')}>
              <IconThumbDown width={16} height={16} />
              <span>1</span>
            </div>
          </div>
        </div>
      </ModalBody>

      <ModalFooter className={cx('ModalFooter')}>
        <Button
          color={themeColor.SECONDARY}
          classes={cx('FooterButton')}
          onClick={onCloseModal}
        >
          Huỷ
        </Button>

        <Button
          color={themeColor.DANGER}
          classes={cx('FooterButton')}
          onClick={onOpenDetailLocation}
        >
          {locationDetail.deletedAt ? 'Khôi phục phản hồi' : 'Xóa phản hồi'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default React.memo(ModalDetailReview);

ModalDetailReview.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func,
  locationDetail: PropTypes.instanceOf(Object),

  onOpenDetailLocation: PropTypes.func.isRequired,
};

ModalDetailReview.defaultProps = {
  onCloseModal: INITIAL_VALUE.FUNCTION,
  locationDetail: null,
};

DiscoverPlace.propTypes = {
  id: PropTypes.string.isRequired,
};
